export enum IdentityType {
    None,
    User,
    Developer,
    Admin,
    FinanceController
}
